<div class="bg-gray-50 py-20 px-4 font-sans relative overflow-hidden">
  <div class="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-orange-100/40 rounded-full blur-3xl">
  </div>

  <div class="max-w-7xl mx-auto relative">
    <div class="text-center mb-16">
      <span class="text-orange-500 font-bold text-sm uppercase tracking-[0.2em] mb-3 block">Why Choose Us</span>
      <h2 class="text-3xl md:text-4xl font-black text-[#001d4a] relative inline-block">
        মেন্টরই<span class="text-orange-500">আরপি</span> কেন নির্ভরযোগ্য ও বেস্ট সলিউশন?
        <div class="mt-2 flex justify-center gap-1">
          <span class="w-12 h-1 bg-orange-500 rounded-full"></span>
          <span class="w-2 h-1 bg-[#001d4a] rounded-full"></span>
        </div>
      </h2>
    </div>

    <div class="max-w-7xl mx-auto px-4 relative group/slider">
      <swiper-container #swiperRef slides-per-view="1" pagination="true" space-between="25"
        breakpoints='{"640": {"slidesPerView": 2}, "1024": {"slidesPerView": 3}, "1280": {"slidesPerView": 3}}'
        autoplay-delay="5000" class="pb-14">
        @for (item of solutions; track $index) {
        <swiper-slide>
          <div class="group h-full py-4">
            <div
              class="relative h-full flex flex-col items-center text-center p-7 rounded-[2rem] bg-white border border-gray-100 shadow-[0_10px_30px_-15px_rgba(0,0,0,0.1)] transition-all duration-500 hover:-translate-y-3 hover:shadow-[0_20px_40px_-20px_rgba(255,120,45,0.3)] hover:border-orange-200">
              <div class="relative mb-6">
                <div
                  class="absolute inset-0 bg-orange-400 blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-500">
                </div>
                <div
                  class="relative w-16 h-16 bg-gradient-to-tr from-[#001d4a] to-[#003d99] text-white rounded-2xl flex items-center justify-center shadow-xl transform transition-transform duration-500 group-hover:rotate-[10deg]">
                  <i [class]="item.icon + ' text-2xl'"></i>
                </div>
              </div>

              <h3
                class="font-bold text-lg text-[#001d4a] mb-5 leading-snug group-hover:text-orange-600 transition-colors">
                {{ item.title }}
              </h3>

              <ul class="space-y-3 text-left w-full mt-auto">
                @for (point of item.points; track $index) {
                <li
                  class="flex items-start text-[13px] leading-relaxed text-gray-500 group-hover:text-gray-700 transition-colors">
                  <i class="fa-solid fa-circle-check text-orange-500 mr-2.5 mt-0.5 text-sm opacity-80"></i>
                  {{ point }}
                </li>
                }
              </ul>
            </div>
          </div>
        </swiper-slide>
        }
      </swiper-container>

      <button (click)="slidePrev()"
        class="absolute left-0 top-[45%] -translate-y-1/2 z-20 w-11 h-11 bg-white text-[#001d4a] shadow-2xl rounded-2xl flex items-center justify-center transition-all duration-500 hover:bg-orange-500 hover:text-white -ml-5 opacity-0 group-hover/slider:opacity-100 group-hover/slider:-ml-2 hidden md:flex border border-gray-50 cursor-pointer">
        <i class="fa-solid fa-arrow-left-long"></i>
      </button>

      <button (click)="slideNext()"
        class="absolute right-0 top-[45%] -translate-y-1/2 z-20 w-11 h-11 bg-white text-[#001d4a] shadow-2xl rounded-2xl flex items-center justify-center transition-all duration-500 hover:bg-orange-500 hover:text-white -mr-5 opacity-0 group-hover/slider:opacity-100 group-hover/slider:-mr-2 hidden md:flex border border-gray-50 cursor-pointer">
        <i class="fa-solid fa-arrow-right-long"></i>
      </button>
    </div>
  </div>
</div>